import {
  AcknowledgementName,
  TaxInformationConsent
} from "@wingspanhq/wingspan-api-sdk";
import { acknowledgementVersions } from "../constants/acknowledgements";

/**
 * Interim attestation text for the payee-side "share my tax information with my
 * client(s)" consent (v3 `payersApi.shareTaxInformation`).
 *
 * TODO(v3): compliance DOUBLE-CHECK — the exact wording, and the interim model of
 * treating the payee's on-file legal name as the e-signature, are PENDING Legal /
 * Product-Marketing sign-off. Revisit before release.
 */
export const TAX_INFORMATION_SHARE_ATTESTATION =
  "I authorize Wingspan to share my tax information, including my Form W-9 and " +
  "verified identity details, with the selected client(s), and I certify that the " +
  "information I have provided is true, correct, and complete.";

/**
 * Builds the v3 `TaxInformationConsent` sent to `payersApi.shareTaxInformation`.
 * Centralized on purpose (a deliberate exception to "prefer duplication"): the
 * attestation statement and consent version MUST stay identical across every
 * share entry point, so they live in one place rather than being re-typed per flow.
 *
 * TODO(v3) INTERIM: `signature` is derived by the caller from the payee's on-file legal name
 * — there is no dedicated e-signature capture yet. Pending Legal / Product-Marketing
 * sign-off (see TAX_INFORMATION_SHARE_ATTESTATION above).
 */
export const buildTaxInformationConsent = (params: {
  signature: string;
  acknowledgementName?: AcknowledgementName;
}): TaxInformationConsent => {
  const acknowledgementName =
    params.acknowledgementName ?? AcknowledgementName.W9_CERTIFICATION;

  return {
    attestationStatement: TAX_INFORMATION_SHARE_ATTESTATION,
    consentVersion: acknowledgementVersions[acknowledgementName],
    attestedAt: new Date(),
    signature: params.signature
  };
};
